<template>
  <div class="animated fadeIn" style="overflow-y:hidden">
    <div class="row">
      <div class="col">
        <span> Rows Per Page:</span>
        <!-- <input v-model="rowsPerPageC" type="number"/> -->
        <b-dropdown id="ddown3" :text="rowsPerPageCText" class="m-md-1" :disabled="showLoadingAnimation">
          <b-dropdown-item href="#" @click="rowsPerPageSelected(10)">10</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(20)">20</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(50)">50</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(100)">100</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(150)">150</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(200)">200</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(500)">500</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(1000)">1000</b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="col" align="center">
        <b-pagination
          size="sm"
          :total-rows="totalRowsC"
          v-model="currentPage"
          :per-page="rowsPerPageC"
          hide-ellipsis
          :limit="paginationButtonsLimit"
          align="center"
          @change="pageChanged"
        >
        </b-pagination>
      </div>
      <div class="col" align="right">
        <span>Total Rows {{totalRowsC}}</span>
      </div>
    </div>

    <br/>
    <button type="button" class="btn btn-primary" @click="refreshTable()" :disabled="showLoadingAnimation">Refresh
    </button>
    <button type="button" class="btn btn-primary" @click="showChangeStatus()" :disabled="showLoadingAnimation">Change
      Status
    </button>
    <button type="button" class="btn btn-primary" @click="showEditCampaign()" :disabled="showLoadingAnimation">Edit
    </button>
    <b-table small bordered hover :items="tableRows" :fields="tableHeaders"
             @row-clicked="tableRowClicked" id="campaignTable">
      <template slot="cell(status)" slot-scope="row">
        <span>{{row.item.status}}</span>
        <button type="button" class="btn btn-primary" @click.stop="showCampaignLivePool(row.item.campaignId)">Live</button>
        <button type="button" class="btn btn-primary" @click.stop="showDetailRow(row.item.campaignId)">Detail</button>
      </template>
      <template slot="row-details" slot-scope="row">
        <b-card-group>
          <b-card>
            <b-row v-for="(note, index) of row.item.notesPool" v-bind:data="note" v-bind:key="note.rewardId || note.noteType + '-' + index">
              <b-col>
                <b>{{getRewardLabel(note)}} has {{getRewardQuantity(note)}} piece(s)</b>
                <span v-if="getRewardValue(note) > 0"> - RM {{getRewardValue(note)}} value each</span>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <b-row v-if="row.item.campaignImageUrl">
              <b-col>
                <b>Campaign Banner</b><br>
                <img :src="row.item.campaignImageUrl" alt="Campaign banner"
                     style="height: 110px; max-width: 260px; object-fit: cover; border-radius: 4px">
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <b-row>
              <b-col><b>Order Types: {{row.item.orderTypes}}</b></b-col>
            </b-row>
          </b-card>
          <b-card>
            <b-row>
              <b-col><b>Lens Designs: {{row.item.lensDesigns}}</b></b-col>
            </b-row>
          </b-card>
          <b-card>
            <b-row>
              <b-col><b>Lens Indexes: {{row.item.lensIndexes}}</b></b-col>
            </b-row>
          </b-card>
        </b-card-group>
      </template>
    </b-table>

    <img src="static/img/Rolling.svg" alt="Loading data..."
         style="margin-left:auto; margin-right:auto; display: block;"
         v-if="showLoadingAnimation">
    <p style="text-align: center"
       v-if="showLoadingError">
      Loading error:
    </p>
    <p style="text-align: center"
       v-if="showNoResult">
      No Result
    </p>

    <!-- Edit status Modal Component -->
    <b-modal id="modal1" title="Change Campaign Status" v-model="showChangeStatusModal">
      <!-- Body -->
      <b-row class="mb-1">
        <b-col><span><b>Campaign: {{selectedRowItem == null ? '' : selectedRowItem.name}}</b></span></b-col>
      </b-row>
      <b-row>
        <b-col><label for="newCampaignStatus">New Status:</label></b-col>
        <b-col>
          <input type="text" id="newCampaignStatus" placeholder="" v-model="newStatus">
          <b-dropdown id="ddown3" :text="newStatus" class="m-md-1">
            <b-dropdown-item href="#" @click="newStatusSelected('ACTIVE')"
                             v-if="selectedRowItemIsDemoCampaign === false">ACTIVE
            </b-dropdown-item>
            <b-dropdown-item href="#" @click="newStatusSelected('DEMO_ACTIVE')" v-else>DEMO_ACTIVE</b-dropdown-item>
            <b-dropdown-item href="#" @click="newStatusSelected('HOLD')">HOLD</b-dropdown-item>
            <b-dropdown-item href="#" @click="newStatusSelected('CLOSED')">CLOSED</b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>
      <!-- Footer -->
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" variant="primary" @click="changeStatus()">
          Change
        </b-btn>
        <b-btn size="sm" class="float-right" variant="primary" @click="closeShowChangeStatusModal()">
          Close
        </b-btn>
      </div>
    </b-modal>

    <MyModal v-if="showUpdatingStatusModal" v-on:close="closeUpdatingStatusModal()" headerTitle="Updating..."
             bodyMessage="Please wait"/>

    <!-- Edit campaign Modal Component -->
    <b-modal id="modal2" title="Edit Campaign" v-model="showEditCampaignModal" size="lg">
      <!-- Body -->
      <b-row class="mb-1">
        <b-col><label for="editedCampaignname">New name:</label></b-col>
        <b-col><input type="text" id="editedCampaignname" placeholder="" v-model="editedCampaignName"
                      style="width:100%"></b-col>
      </b-row>
      <b-row>
        <b-col><label for="editedCampaigndescription">New Description:</label></b-col>
        <b-col><input type="text" id="editedCampaigndescription" placeholder="" v-model="editedCampaignDescription"
                      style="width:100%"></b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col><label for="editedCampaignBanner">Campaign Banner:</label></b-col>
        <b-col>
          <div v-if="editedCampaignImageUrl" class="mb-2">
            <img :src="editedCampaignImageUrl" alt="Campaign banner"
                 style="height: 110px; max-width: 260px; object-fit: cover; border-radius: 4px">
          </div>
          <input type="file" id="editedCampaignBanner" accept="image/*" @change="editedCampaignBannerChanged($event.target.files)">
          <small class="form-text text-muted">Choose a new file only when replacing the current banner.</small>
        </b-col>
      </b-row>
      <b-row>
        <b-col><label for="editedCampaignStartDate">New Start Date:</label></b-col>
        <b-col>
          <DateTimePicker format="DD/MM/YYYY h:i:s" id="editedCampaignStartDate"
                          v-on:update:date-value="updateCampaignStartDate"
                          ref="editCampaignStartDateRef"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col><label for="editedCampaignEndDate">New End Date:</label></b-col>
        <b-col>
          <DateTimePicker format="DD/MM/YYYY h:i:s" id="editedCampaignEndDate"
                          v-on:update:date-value="updateCampaignEndDate"
                          ref="editCampaignEndDateRef"/>
        </b-col>
      </b-row>
      <br/>
      <b-row>
        <b-col><label for="editedCampaignInvoiceStartDate">New Invoice Start Date:</label></b-col>
        <b-col>
          <DateTimePicker format="DD/MM/YYYY h:i:s" id="editedCampaignInvoiceStartDate"
                          v-on:update:date-value="updateInvoiceStartDate"
                          ref="editCampaignStartInvoiceDateRef"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col><label for="editedCampaignInvoiceEndDate">New Invoice End Date:</label></b-col>
        <b-col>
          <DateTimePicker format="DD/MM/YYYY h:i:s" id="editedCampaignInvoiceEndDate"
                          v-on:update:date-value="updateInvoiceEndDate"
                          ref="editCampaignEndInvoiceDateRef"/>
        </b-col>
      </b-row>
      <br/>
      <b-row>
        <b-col><label for="editedCampaignMinimumPrice">New Minimum Price:</label></b-col>
        <b-col><input type="number" id="editedCampaignMinimumPrice" placeholder=""
                      v-model="editedCampaignMinimumInvoicePerPiece"></b-col>
      </b-row>
      <br/>
      <b-row>
        <b-col><label for="isDemoAccount">Is Demo Campaign:</label></b-col>
        <b-col><input type="checkbox" id="isDemoAccount" placeholder="" name="Is Demo Account"
                      v-model="editedIsDemoAccount"></b-col>
      </b-row>
      <b-row>
        <b-col>
          Order Types<br/>
          <ul class="list-group" id="editedCampaignEligibleOrderTypes" style="max-height:200px; overflow-y:auto">
            <li class="list-group-item" v-for="item in editedCampaignAvailableEligibleOrderTypes">
              <input type="checkbox" :name="item" :value="item" v-model="editedCampaignSelectedEligibleOrderTypes"/>
              <span>{{item}}</span>
            </li>
          </ul>
        </b-col>
        <b-col>
          Lens Design<br/>
          <ul class="list-group" id="editedCampaignEligibleLensDesigns" style="max-height:200px; overflow-y:auto">
            <li class="list-group-item" v-for="item in editedCampaignAvailableEligibleLensDesign">
              <input type="checkbox" :name="item" :value="item" v-model="editedCampaignSelectedEligibleLensDesign"/>
              <span>{{item}}</span>
            </li>
          </ul>
        </b-col>
        <b-col>
          Lens Index<br/>
          <ul class="list-group" id="editedCampaignEligibleLensIndexes" style="max-height:200px; overflow-y:auto">
            <li class="list-group-item" v-for="item in editedCampaignAvailableEligibleLensIndex">
              <input type="checkbox" :name="item" :value="item" v-model="editedCampaignSelectedEligibleLensIndex"/>
              <span>{{item}}</span>
            </li>
          </ul>
        </b-col>
      </b-row>
      <br/>
      <b-card>
        <b-row class="mb-2 align-items-center">
          <b-col>
            <b>Rewards</b><br/>
            <small class="text-muted">Quantity cannot be reduced below the claimed amount. Claimed rewards cannot be deleted.</small>
          </b-col>
          <b-col cols="auto">
            <b-btn size="sm" variant="primary" @click="addEditedCampaignReward()">Add Reward</b-btn>
          </b-col>
        </b-row>
        <b-row v-for="(reward, index) in editedCampaignRewards" :key="reward.rewardId || index" class="mb-2 align-items-end">
          <b-col md="3">
            <label>Reward Name / Amount</label>
            <input type="text" class="form-control" placeholder="RM 10, Sensity voucher" v-model="reward.rewardLabel"/>
          </b-col>
          <b-col md="2">
            <label>Type</label>
            <input type="text" class="form-control" :value="reward.rewardType" disabled/>
          </b-col>
          <b-col md="2">
            <label>Cash Value</label>
            <input type="number" class="form-control" :value="reward.rewardValue" disabled/>
          </b-col>
          <b-col md="2">
            <label>Quantity</label>
            <input type="number" min="0" class="form-control" v-model.number="reward.totalQuantity"/>
          </b-col>
          <b-col md="1">
            <label>Claimed</label>
            <div class="form-control-plaintext">{{getRewardClaimedQuantity(reward)}}</div>
          </b-col>
          <b-col md="2">
            <b-btn size="sm" variant="danger" @click="removeEditedCampaignReward(index)" :disabled="getRewardClaimedQuantity(reward) > 0">Remove</b-btn>
          </b-col>
        </b-row>
      </b-card>
      <!-- Footer -->
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" variant="primary" @click="editCampaign()">
          Change
        </b-btn>
        <b-btn size="sm" class="float-right" variant="primary" @click="closeEditCampaignModal()">
          Close
        </b-btn>
      </div>
    </b-modal>

    <MyModal v-if="showUpdateSuccessModal" v-on:close="closeUpdateSuccessModal()" headerTitle="Success"
             bodyMessage="Updated successfully"/>

    <MyModal v-if="showUpdateFailModal" v-on:close="closeUpdateFailModal()" headerTitle="Failed"
             v-bind:bodyMessage="updateFailMessage"/>

    <!-- Live Data Modal Component -->
    <b-modal id="modal3" :title="campaignLiveModalTitle" v-model="showCampaignLiveModal" size="lg">
      <!-- Body -->
      <b-row class="mb-1">
        <b-col><span><b>Campaign: {{selectedRowItem == null ? '' : selectedRowItem.name}}</b></span></b-col>
      </b-row>
      <br/>
      <b-row>
        <b-col>
          <span>Monetary Summary: RM {{campaignMoneyPool.totalPrizeMoney}}</span>
        </b-col>
        <b-col>
          <span>Monetary Claimed: RM {{campaignMoneyPool.claimedPrizeMoney}}</span>
        </b-col>
        <b-col>
          <span>Monetary Remaining: RM {{campaignMoneyPool.totalPrizeMoney - campaignMoneyPool.claimedPrizeMoney}}</span>
        </b-col>
      </b-row>
      <br/>
      <b-row v-for="(note, index) of campaignMoneyPool.notesPool" :key="note.rewardId || note.noteType + '-' + index">
        <b-col>
          <span>Total: {{getRewardQuantity(note)}} piece(s) of {{getRewardLabel(note)}}</span>
        </b-col>
        <b-col>
          <span>Claimed: {{getRewardClaimedQuantity(note)}} piece(s)</span>
        </b-col>
        <b-col>
          <span>Remaining: {{getRewardQuantity(note) - getRewardClaimedQuantity(note)}} piece(s)</span>
        </b-col>
        <br/>
      </b-row>
      <!-- Footer -->
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="primary" @click="closeCampaignLiveModal()">
          Close
        </b-btn>
      </div>
    </b-modal>

  </div>
  <!--</div>-->
</template>

<script>
import {DateTimePicker, MyModal} from '../components/'

export default {
  components: {
    DateTimePicker,
    MyModal
  },
  data () {
    return {
      currentPage: this.$store.state.cammod.currentPage,
      paginationButtonsLimit: 3,
      selectedRowItem: null,
      newStatus: ''
    }
  },
  created: function () {
    // we hook into the created lifecycle to start grabbing data from firestore
    this.$store.dispatch('cammod/showAllCampaigns', {orderBys: 'createdDate'})
  },
  updated: function () {
    // console.log('VUEJS updated hook!')
    let tableElement = document.getElementsByTagName('table')[0]
    let tableOriginalWidth = tableElement.offsetWidth
    // console.log('table width: ' + tableOriginalWidth)

    let tableHeaders = document.getElementsByTagName('th')
    // console.log('tableHeaders: ' + tableHeaders.length)
    let tableBodyCells = document.getElementsByTagName('td')
    // console.log('tableBodyCells: ' + tableBodyCells.length)
    if (tableHeaders.length > 0 && tableBodyCells.length > 0) {
      let totalColumnWidth = 0
      tableElement.style.width = (tableOriginalWidth * 4) + 'px'
      tableElement.style.maxWidth = (tableOriginalWidth * 4) + 'px'
      // console.log('Post Process: Updated table width to: ' + tableElement.offsetWidth)
      // let totalDiffs = 0
      for (let i = 0; i < tableHeaders.length; i++) {
        let headerWidth = tableHeaders[i].offsetWidth
        let cellWidth = tableBodyCells[i].offsetWidth
        // console.log(i + '-Header width: ' + headerWidth)
        // console.log(i + '-Cell width: ' + cellWidth)
        if (headerWidth < cellWidth) {
          tableHeaders[i].style.width = cellWidth + 'px'
          // console.log('updated header width to: ' + tableHeaders[i].getBoundingClientRect().width)
          totalColumnWidth = totalColumnWidth + tableHeaders[i].offsetWidth
        } else if (cellWidth < headerWidth) {
          tableBodyCells[i].style.width = headerWidth + 'px'
          // console.log('update cell width to: ' + tableBodyCells[i].getBoundingClientRect().width)
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth
        } else {
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth
        }
      }
      if (totalColumnWidth > 0) {
        tableElement.style.width = totalColumnWidth + 'px'
        tableElement.style.maxWidth = totalColumnWidth + 'px'
        // console.log('Updated table width to: ' + tableElement.offsetWidth)
      }
    }
  },
  methods: {
    pageChanged: function (pageNumber) {
      this.currentPage = pageNumber
      console.log('User changed page to number: ' + this.currentPage)
      this.$store.commit('cammod/changePageNumber', this.currentPage)
      this.$store.dispatch('cammod/showAllCampaigns', {orderBys: 'createdDate'})
    },
    rowsPerPageSelected: function (rows) {
      console.log('rowsPerPageSelected, rows: ' + rows)
      let intRows = parseInt(rows)
      if (this.$store.state.cammod.rowsPerPage !== intRows) {
        this.currentPage = 1
        this.$store.commit('cammod/changePageNumber', this.currentPage)
        this.$store.commit('cammod/setRowsPerPage', intRows)
        this.$store.dispatch('cammod/showAllCampaigns', {orderBys: 'createdDate'})
      }
    },
    newStatusSelected: function (selectedStatus) {
      this.newStatus = selectedStatus
      console.log('selected new status: ' + this.newStatus)
    },
    tableRowClicked: function (item, index, event) {
      console.log('Table row clicked, index:' + index + ' item:' + item + ' event:' + event)
      // for (let i in item) {
      //   console.log('i:' + i)
      // }
      this.$store.commit('cammod/selectTableRow', item.campaignId)
      this.selectedRowItem = item
    },
    refreshTable: function () {
      this.$store.dispatch('cammod/showAllCampaigns', {orderBys: 'createdDate'})
    },
    showChangeStatus: function () {
      if (this.selectedRowItem) {
        this.newStatus = ''
        this.$store.commit('cammod/toggleShowChangeStatusModal', true)
      }
    },
    showEditCampaign: function (campaign) {
      if (campaign) {
        this.selectedRowItem = campaign
        this.$store.commit('cammod/selectTableRow', campaign.campaignId)
      }
      if (this.selectedRowItem) {
        // get all available order types
        this.$store.dispatch('cammod/fetchAvailableOrderTypesFromFirestore')
        // get all available lens designs
        this.$store.dispatch('cammod/fetchAvailableLensDesignsFromFirestore')
        // get all available lens indexes
        this.$store.dispatch('cammod/fetchAvailableLensIndexesFromFirestore')

        this.$store.commit('cammod/updateNewCampaignId', this.selectedRowItem.campaignId)
        this.$store.commit('cammod/updateNewCampaignName', this.selectedRowItem.name)
        this.$store.commit('cammod/updateNewCampaignDescription', this.selectedRowItem.description)
        this.$store.commit('cammod/updateNewCampaignImageUrl', this.selectedRowItem.campaignImageUrl)
        this.$store.commit('cammod/updateNewCampaignImageStoragePath', this.selectedRowItem.campaignImageStoragePath)
        this.$store.commit('cammod/updateEditedCampaignBannerFile', null)
        this.$store.commit('cammod/updateminimumInvoicePerPiece', this.selectedRowItem.minimumPrice)
        this.$store.commit('cammod/updateEligibleLenseDesigns', this.selectedRowItem.lensDesigns)
        this.$store.commit('cammod/updateEligibleOrderTypes', this.selectedRowItem.orderTypes)
        this.$store.commit('cammod/updateEligibleLensIndexes', this.selectedRowItem.lensIndexes || [])
        this.$store.commit('cammod/updateEditedCampaignRewards', this.selectedRowItem.notesPool || [])
        this.$store.dispatch('cammod/fetchEditedCampaignLiveRewards', {campaignId: this.selectedRowItem.campaignId})

        if (this.selectedRowItem.demo) {
          this.$store.commit('cammod/updateEditedIsDemoAccount', this.selectedRowItem.demo)
        } else {
          this.$store.commit('cammod/updateEditedIsDemoAccount', false)
        }

        this.$store.commit('cammod/toggleShowEditCampaignModal', true)
        this.$nextTick(function () {
          if (this.$refs.editCampaignStartDateRef) {
            this.$refs.editCampaignStartDateRef.setInitialDate(this.selectedRowItem.startDate)
          }
          if (this.$refs.editCampaignEndDateRef) {
            this.$refs.editCampaignEndDateRef.setInitialDate(this.selectedRowItem.endDate)
          }
          if (this.$refs.editCampaignStartInvoiceDateRef) {
            this.$refs.editCampaignStartInvoiceDateRef.setInitialDate(this.selectedRowItem.invoiceStartDate)
          }
          if (this.$refs.editCampaignEndInvoiceDateRef) {
            this.$refs.editCampaignEndInvoiceDateRef.setInitialDate(this.selectedRowItem.invoiceEndDate)
          }
        })
      }
    },
    changeStatus: function () {
      this.$store.dispatch('cammod/updateCampaignStatus',
        {
          campaignId: this.selectedRowItem.campaignId,
          newStatus: this.newStatus,
          totalPrizeMoney: this.selectedRowItem.totalPrizeMoney,
          notesPool: this.selectedRowItem.notesPool
        }
      )
    },
    editCampaign: function () {
      this.$store.dispatch('cammod/updateCampaign', {campaignId: this.selectedRowItem.campaignId})
    },
    addEditedCampaignReward: function () {
      this.$store.commit('cammod/addEditedCampaignReward')
    },
    removeEditedCampaignReward: function (index) {
      this.$store.commit('cammod/removeEditedCampaignReward', index)
    },
    editedCampaignBannerChanged: function (fileList) {
      let file = fileList && fileList.length > 0 ? fileList[0] : null
      this.$store.commit('cammod/updateEditedCampaignBannerFile', file)
    },
    closeUpdatingStatusModal: function () {
      this.$store.commit('cammod/toggleShowUpdatingStatusModal', false)
    },
    closeShowChangeStatusModal: function () {
      this.$store.commit('cammod/toggleShowChangeStatusModal', false)
    },
    closeUpdateSuccessModal: function () {
      this.$store.commit('cammod/toggleshowUpdateSuccessModal', false)
    },
    closeUpdateFailModal: function () {
      this.$store.commit('cammod/toggleShowUpdateFailModal', false)
    },
    closeEditCampaignModal: function () {
      this.$store.commit('cammod/toggleShowEditCampaignModal', false)
    },
    updateCampaignStartDate: function (dateString) {
      this.$store.commit('cammod/updateNewCampaignStartDate', dateString)
    },
    updateCampaignEndDate: function (dateString) {
      this.$store.commit('cammod/updateNewCampaignEndDate', dateString)
    },
    updateInvoiceStartDate: function (dateString) {
      this.$store.commit('cammod/updateNewInvoiceStartDate', dateString)
    },
    updateInvoiceEndDate: function (dateString) {
      this.$store.commit('cammod/updateNewInvoiceEndDate', dateString)
    },
    showCampaignLivePool: function (campaignId) {
      for (let i = 0; i < this.tableRows.length; i++) {
        if (this.tableRows[i].campaignId === campaignId) {
          this.selectedRowItem = this.tableRows[i]
          this.$store.commit('cammod/selectTableRow', campaignId)
          break
        }
      }
      this.$store.commit('cammod/toggleShowCampaignLiveModal', true)
      this.$store.dispatch('cammod/showCampaignMoneyPool', {campaignId: campaignId})
    },
    showDetailRow: function (campaignId) {
      this.$store.commit('cammod/toggleShowHideRowDetail', campaignId)
    },
    closeCampaignLiveModal: function () {
      this.$store.commit('cammod/turnOffLiveCampignListener')
      this.$store.commit('cammod/toggleShowCampaignLiveModal', false)
    },
    getRewardValue: function (reward) {
      return Number(reward.rewardValue || reward.noteType || 0)
    },
    getRewardQuantity: function (reward) {
      return Number(reward.totalQuantity || reward.noteAmount || 0)
    },
    getRewardClaimedQuantity: function (reward) {
      return Number(reward && (reward.claimedQuantity || reward.claimedAmount) || 0)
    },
    getRewardLabel: function (reward) {
      if (!reward) {
        return 'Reward'
      }
      if (reward.rewardLabel && reward.rewardLabel.length > 0) {
        return reward.rewardLabel
      }
      let rewardValue = this.getRewardValue(reward)
      return rewardValue > 0 ? 'RM ' + rewardValue : 'Reward'
    }
  },
  computed: {
    tableRows: function () {
      return this.$store.state.cammod.all
    },
    tableHeaders: function () {
      return this.$store.getters['cammod/getHeaders']
    },
    campaignLiveModalTitle: function () {
      if (this.selectedRowItem && this.selectedRowItem.name) {
        return 'Campaign Reward Pool Live Data - ' + this.selectedRowItem.name
      }
      return 'Campaign Reward Pool Live Data'
    },
    totalRowsC: function () {
      return this.$store.state.cammod.totalRows
    },
    rowsPerPageC: {
      get: function () {
        return this.$store.state.cammod.rowsPerPage
      },
      set: function (newValue) {
        this.$store.commit('cammod/setRowsPerPage', newValue)
      }
    },
    rowsPerPageCText: function () {
      return '' + this.$store.state.cammod.rowsPerPage
    },
    showUpdatingStatusModal: function () {
      return this.$store.state.cammod.showUpdatingStatusModal
    },
    showChangeStatusModal: {
      get: function () {
        return this.$store.state.cammod.showChangeStatusModal
      },
      set: function (newValue) {
        this.$store.commit('cammod/toggleShowChangeStatusModal', newValue)
      }
    },
    showUpdateSuccessModal: function () {
      return this.$store.state.cammod.showUpdateSuccessModal
    },
    showUpdateFailModal: function () {
      return this.$store.state.cammod.showUpdateFailModal
    },
    showEditCampaignModal: {
      get: function () {
        return this.$store.state.cammod.showEditCampaignModal
      },
      set: function (newValue) {
        this.$store.commit('cammod/toggleShowEditCampaignModal', newValue)
      }
    },
    editedCampaignName: {
      get: function () {
        return this.$store.state.cammod.editedCampaign.name
      },
      set: function (newValue) {
        this.$store.commit('cammod/updateNewCampaignName', newValue)
      }
    },
    editedCampaignDescription: {
      get: function () {
        return this.$store.state.cammod.editedCampaign.description
      },
      set: function (newValue) {
        this.$store.commit('cammod/updateNewCampaignDescription', newValue)
      }
    },
    editedCampaignImageUrl: function () {
      return this.$store.state.cammod.editedCampaign.campaignImageUrl
    },
    editedCampaignStartDate: {
      get: function () {
        return this.$store.getters['cammod/getEditedCampaignStartDate']
      }
      // ,
      // set: function (newValue) {
      //   this.$store.commit('cammod/updateNewCampaignStartDate', newValue)
      // }
    },
    editedCampaignEndDate: {
      get: function () {
        return this.$store.getters['cammod/getEditedCampaignEndDate']
      }
      // ,
      // set: function (newValue) {
      //   this.$store.commit('cammod/updateNewCampaignEndDate', newValue)
      // }
    },
    editedCampaignInvoiceStartDate: {
      get: function () {
        return this.$store.getters['cammod/getEditedCampaignInvoiceStartDate']
      }
      // ,
      // set: function (newValue) {
      //   this.$store.commit('cammod/updateNewInvoiceStartDate', newValue)
      // }
    },
    editedCampaignInvoiceEndDate: {
      get: function () {
        return this.$store.getters['cammod/getEditedCampaignInvoiceEndDate']
      }
      // ,
      // set: function (newValue) {
      //   this.$store.commit('cammod/updateNewInvoiceEndDate', newValue)
      // }
    },
    editedCampaignRewards: function () {
      return this.$store.state.cammod.editedCampaign.notesPool
    },
    editedCampaignMinimumInvoicePerPiece: {
      get: function () {
        return this.$store.state.cammod.editedCampaign.minimumInvoicePerPiece
      },
      set: function (newValue) {
        this.$store.commit('cammod/updateminimumInvoicePerPiece', newValue)
      }
    },
    editedIsDemoAccount: {
      get: function () {
        return this.$store.state.cammod.editedCampaign.editedIsDemoAccount
      },
      set: function (newValue) {
        this.$store.commit('cammod/updateEditedIsDemoAccount', newValue)
      }
    },
    showCampaignLiveModal: {
      get: function () {
        return this.$store.state.cammod.showCampaignLiveModal
      },
      set: function (newValue) {
        if (newValue === false) {
          console.log('setter show campaign live modal to false')
          this.$store.commit('cammod/turnOffLiveCampignListener')
        }
        this.$store.commit('cammod/toggleShowCampaignLiveModal', newValue)
      }
    },
    campaignMoneyPool: {
      get: function () {
        return this.$store.state.cammod.campaignMoneyPool
      }
    },
    editedCampaignAvailableEligibleOrderTypes: {
      get: function () {
        return this.$store.state.cammod.editedCampaign.availableEligibleOrderTypes
      }
    },
    editedCampaignSelectedEligibleOrderTypes: {
      get: function () {
        return this.$store.state.cammod.editedCampaign.eligibleOrderTypes
      },
      set: function (items) {
        this.$store.commit('cammod/updateEligibleOrderTypes', items)
      }
    },
    editedCampaignAvailableEligibleLensDesign: {
      get: function () {
        return this.$store.state.cammod.editedCampaign.availableEligibleLensDesigns
      }
    },
    editedCampaignSelectedEligibleLensDesign: {
      get: function () {
        return this.$store.state.cammod.editedCampaign.eligibleLensDesigns
      },
      set: function (items) {
        this.$store.commit('cammod/updateEligibleLenseDesigns', items)
      }
    },
    editedCampaignAvailableEligibleLensIndex: {
      get: function () {
        return this.$store.state.cammod.editedCampaign.availableEligibleLensIndexes
      }
    },
    editedCampaignSelectedEligibleLensIndex: {
      get: function () {
        return this.$store.state.cammod.editedCampaign.eligibleLensIndexes
      },
      set: function (items) {
        this.$store.commit('cammod/updateEligibleLensIndexes', items)
      }
    },
    selectedRowItemIsDemoCampaign: function () {
      if (this.selectedRowItem && this.selectedRowItem.hasOwnProperty('demo') && this.selectedRowItem.demo === true) {
        return true
      }
      return false
    },
    showLoadingAnimation: function () {
      return this.$store.state.cammod.showLoadingAnimation
    },
    updateFailMessage: function () {
      return this.$store.state.cammod.loadingErrorMessage || 'Update failed'
    },
    showLoadingError: function () {
      return this.$store.state.cammod.showLoadingError
    },
    showNoResult: function () {
      return this.$store.state.cammod.showNoResult
    }
  },
  name: 'campaigns'
}
</script>



// WEBPACK FOOTER //
// src/views/Campaigns.vue